<template>
  <!-- 开发人员：张亚欣 -->
  <div class="objectTableMain">
    <div class="object_box">
      <!-- 顶部按钮功能操作区域 -->
      <div class="topContent">
        <!-- 左侧快捷操作按钮 -->
        <div class="left-content">
          <input id="viewId" type="hidden" v-model="viewId" />
          <input id="ids" type="hidden" v-model="ids" />
          <!-- 过滤器 -->
          <Filterbutton @filterBoard="filterBoard" v-if="showFilter" />
          <!-- 视图切换器 -->
          <ViewToggle
            ref="chooseviewRef"
            v-show="selectedList.length === 0"
            class="pull-left"
            :viewId="viewId"
            :view-list="viewList"
            :view-name="viewName"
            :objId="objId"
            :prefix="prefix"
            :type="type"
            :create-view="createView"
            :copyForm="copyForm"
            @changeView="changeView"
            @getViewList="getViewList"
            @getViewId="getViewId"
            @refresh="refresh"
            @actives="actives"
            @handleView="handleView(arguments)"
            @openCopyView="openCopyView"
            @updateViewList="updateViewList"
            @updateDefaultView="updateDefaultView"
          ></ViewToggle>
          <!-- 布局切换器 -->
          <LayoutToggle
            v-show="selectedList.length === 0"
            class="pull-left"
            :views-type-list="viewsTypeList"
            @tableView="tableView"
            @boardView="boardView"
            @multiScreen="multiScreen"
          ></LayoutToggle>
          <!-- 多选时数量统计 -->
          <SelectSize
            v-show="selectedList.length > 0"
            :selectedList="selectedList"
            @cancelBatchOperation="cancelBatchOperation"
          ></SelectSize>
          <!-- 多选时批量操作按钮 -->
          <BatchButton
            ref="batchOperationButtons"
            v-show="selectedList.length > 0"
            :selectedList="selectedList"
            :show-buttons="showBtns"
            :isTag="isTag"
            :tab-name="tabName"
            :type="type"
            :objId="objId"
            :viewId="viewId"
            :view-name="viewName"
            :reportList="reportList"
            :prefix="prefix"
            :viewInfos="viewInfo"
            :totalSize="totalSize"
            :showScreen="showScreen"
            @refresh="refresh"
            @addTag="addTag"
            @planView="planView"
            @tagManage="tagManage"
            @chartsBoard="chartsBoard"
            @print="print"
            @reportBoard="reportBoard"
            @cancelBatchOperation="cancelBatchOperation"
            @refreshAfterBatchDelete="refreshAfterBatchDelete"
          ></BatchButton>
          <!-- 搜索框 -->
          <SearchWrapper
            v-show="objectApi !== 'CloudccKArticle'"
            ref="searchWrapper"
            width="160px"
            class="searchWrapper pull-right"
            :placeholder="$t('vue_label_commonobjects_view_searchthisview')"
            :exact-search-flag="exactSearchFlag"
            :exact-search-field-list="exactSearchFieldList"
            @changeKeyWord="changeKeyWord"
          ></SearchWrapper>
        </div>
        <!-- 视图新增类和普通操作类按钮 -->
        <div class="right-content">
          <!-- 自定义按钮 -->
          <CustomButton
            class="pull-right"
            ref="wrapper"
            :selectedList="selectedList"
            :viewId="viewId"
            :prefix="prefix"
            :tabName="tabName"
            :show-buttons="showCustomButtons"
            :type="type"
            @refresh="refresh"
          ></CustomButton>

          <!-- 常用按钮 -->
          <HotButton
            class="pull-right"
            style="margin-left: 8px"
            ref="wrapper"
            :selectedList="selectedList"
            :addable="addable"
            :viewId="viewId"
            :prefix="prefix"
            :tabName="tabName"
            :show-buttons="showBtns"
            :other-buttons="showButtons"
            :type="type"
            @add="add"
            @refresh="refresh"
            @change="refresh"
            @createdtemplainit="createdtemplainit"
          ></HotButton>

          <!-- 其他按钮 -->
          <OtherButton
            class="pull-right"
            style="margin-left: 8px"
            ref="wrapper"
            :selectedList="selectedList"
            :addable="addable"
            :viewId="viewId"
            :prefix="prefix"
            :tabName="tabName"
            :show-buttons="showBtns"
            :other-buttons="showButtons"
            :type="type"
            @add="add"
            @addTag="addTag"
            @refresh="refresh"
            @mailchimp="mailchimp"
            @change="refresh"
            @createdtemplainit="createdtemplainit"
            @export="exportView"
            @print="print"
            @tagManage="tagManage"
            @chartsBoard="chartsBoard"
            @salesFunnel="salesFunnel"
            @promotionOfSalesStage="promotionOfSalesStage"
            @highSpoolAction="highSpoolAction"
          ></OtherButton>
        </div>
      </div>
      <!-- 内容主区域 -->
      <div class="main-content-box" ref="mainContentBox">
        <!-- 筛选器 -->
        <FilterPanel
          class="screen"
          v-if="showScreen"
          :viewInfos="viewInfo"
          :view-id="viewId"
          :objId="objId"
          :prefix="prefix"
          :filterField="filterField"
          @viewIds="viewIds"
          ref="filterPanel"
          @filterBoard="filterBoard"
          @changeConditionValues="changeConditionValues"
          :curPushData="curPushData"
          :curHeader="curHeader"
        ></FilterPanel>

        <!-- 列表 -->
        <TablePanel
          closeLoadMore
          class="tablePanel"
          ref="tablePanel"
          v-if="!showKanban && !showPlan"
          :headerEditInfo="headerEditInfo"
          :editFlag.sync="editFlag"
          :editId="id"
          :isQueryCount="isQueryCount"
          :border="true"
          :showScreen="showScreen"
          :filterField="filterField"
          :show-index="true"
          :checked="true"
          :ismodifyFalg="ismodifyFalg"
          :customHeader="true"
          :prefix="prefix"
          :obj-id="objId"
          :object-api="objectApi"
          :view-id="viewId"
          :view-modify="ismodifyFalg"
          :page-num="pageNum"
          :total="totalSize"
          :page-size-list.sync="pageSize"
          :current-page.sync="skippageNum"
          :table-attr="tableAttr"
          :page-obj="pageObj"
          :table-button="tableBtnList"
          :noDataTip="noDataTip"
          :sortField="sortField"
          :sortDir="sortDir"
          :viewSelectedFieldList="viewSelectedFieldList"
          :viewUnselectedFieldList="viewUnselectedFieldList"
          :pict-loading="pictLoading"
          :enableInlineEdit="
            $store.state.userInfoObj.enableInlineEdit !== 'false'
          "
          @getViewListData="getViewListData"
          @searchViewDetail="searchViewDetail"
          @changeSortFiled="changeSortFiled"
          @changeFilterFiled="changeFilterFiled"
          @wordWrap="wordWrap"
          @locked="locked"
          @edit="edit"
          @del="del"
          @marktemplate="marktemplate"
          @transferOwner="transferOwner"
          @transferClientOwner="transferClientOwner"
          @handleChange="handleChange"
          @saveSelectedField="saveSelectedField"
          @onchange="onchange"
          @refresh="refresh"
          @save="save"
        ></TablePanel>

        <!-- 看板视图 -->
        <kanban
          v-if="showKanban && !showPlan"
          ref="kanban"
          @chat="chat"
          @longitude="longitude"
          @activeName="activeName"
          :kanBanData="kanBanData"
          :selectedList="selectedList"
          :ismodifyFalg="ismodifyFalg"
        ></kanban>
      </div>

      <!-- 计划-排班表-->
      <shift-plan
        ref="shiftPlan"
        :viewId="viewId"
        v-if="!showKanban && showPlan"
      ></shift-plan>

      <!-- 删除数据提示 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :title="$t('label.delete')"
        top="15%"
        width="25%"
        :close-on-click-modal="false"
        :before-close="handleClose"
      >
        <span
          style="font-size: 16px; font-weight: bold; word-break: break-word"
        >
          <!-- 确认删除该条数据吗？ -->
          {{ delContent }}
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="mini">
            <!-- 取消 -->
            {{ $t("label.cancel") }}
          </el-button>
          <el-button
            @click="confirmDel"
            type="primary"
            size="mini"
            :loading="isBtnLoading"
          >
            <!-- 删除 -->
            {{ $t("label.delete") }}
          </el-button>
        </span>
      </el-dialog>

      <!-- 更改所有人 -->
      <transfer-owner-dialog
        ref="transferClientOwner"
        :id="id"
        :objId="objId"
        :transfer-deault="transferDeault"
        :owner-type-list="ownerTypeList"
        :owner-raletion-list="ownerRaletionList"
        :transfer-client-owner-dialog="transferClientOwnerDialog"
        @closeTransferOwnerDialog="closeTransferOwnerDialog"
        @saveTransferOwner="saveTransferOwner"
      ></transfer-owner-dialog>

      <!-- 视图新建、编辑 -->
      <CreateEditView
        ref="createEditView"
        :dialongViewTo="dialongViewTo"
        :title.sync="title"
        :viewUnselectedFieldList="viewUnselectedFieldList"
        :viewcell="viewcell"
        :visibFlag.sync="visibFlag"
        :selectedFieldIds.sync="selectedFieldIds"
        :selectedGroupList="selectedGroupList"
        :objFormVal="objForm"
        :checked="checked"
        :isQueueSelect.sync="isQueueSelect"
        :queryQueueValue.sync="queryQueueValue"
        :isQueue="isQueue"
        :queryQueueList="queryQueueList"
        :loading="loading"
        :isUsedForMobile.sync="isUsedForMobile"
        :selLength="selLength"
        :formLabelWidth="formLabelWidth"
        :optionst_one="optionst_one"
        :optionst_two="optionst_two"
        :objId="objId"
        :viewId="enViewId"
        :prefix="prefix"
        :copyForm="copyForm"
        :customBtns="customButtons"
        :checkCustomBtns="checkCustomButtons"
        :viewSelectedFieldList="viewSelectedFieldList"
        @updateCheckCustomBtns="updateCheckCustomBtns"
        @closeViewDialog="closeViewDialog"
        @getViewId="getViewId"
      ></CreateEditView>

      <!-- 标签列表 -->
      <LabelView
        class="LabelView"
        v-if="isLabelView"
        :objId="objId"
        :tabName="tabName"
        :getViewListDataParams="getViewListDataParams"
        @tagValue="tagValues"
        @gb="getMsgFormSon"
      ></LabelView>

      <!-- 图表列表 -->
      <Chart
        v-if="isChart"
        class="chart"
        :ismodifyFalg="ismodifyFalg"
        :view-id="viewId"
        :listDashboard="listDashboard"
        :loadingDashboard="loadingDashboard"
      ></Chart>

      <!-- 新增/修改记录 -->
      <CreateEditObj
        ref="createEditObj"
        :prefix="prefix"
        :id="id"
        :objectApi="objectApi"
        :object-name="tabName"
        :realObjId="objId"
        :isTableEdit="isTableEdit"
        @save="save"
      ></CreateEditObj>

      <!-- 添加标签 -->
      <div class="add_label">
        <add-label
          :ids="ids"
          :objId="objId"
          @refresh="refresh"
          @addTag="addTag"
          ref="addlabel"
        ></add-label>
      </div>
    </div>

    <!-- 导出至MailChimp -->
    <MailChimp
      ref="MailChimp"
      :listData="ids"
      :prefix="prefix"
      :viewId="viewId"
      :tabName="tabName"
      @MailChimpSelect="MailChimpSelect"
      :selectedList="selectedList"
      @refresh="refresh"
    ></MailChimp>
    <!-- 开启/关闭公海池弹窗 -->
    <HighSeasPool
      :dialogVisible="highSeasPdialog"
      :objid="objId"
      :highSeaPoolStatus="highSeaPoolStatus"
      @closeDialog="closeDialog"
    >
    </HighSeasPool>
  </div>
</template>

<script>
/**
 * 对象数据的列表展示页
 * 功能：
 *  1.过滤功能，根据视图可以过滤的字段，动态渲染过滤视图，通过过滤条件筛选列表数据
 *  2.新建视图和视图切换功能，视图是不同条件和展示不同字段的组合
 *  3.展示形式切换，一个表格的数据可以用不同的形式展示：列表，看板、分屏
 *  4.关键字搜索，通过关键字过滤数据
 *  5.数据的特殊操作：新建，编辑，删除，更改所有人等等，功能列表跟对象相关联
 */
import { LabelView, TransferOwnerDialog } from "@/components/index";
import Chart from "@/views/commonObjects/components/chart.vue";
import TransferOwnerMixin from "@/mixin/transferOwner.js";
import Kanban from "@/views/commonObjects/components/kanban.vue";
import shiftPlan from "@/views/commonObjects/components/shiftPlan";
import createButton from "@/utils/Button";
import { Message } from "element-ui";
import * as CommonObjApi from "./api.js";
import addLabel from "@/components/LabelView/addTag.vue";
import * as types from "@/store/mutations-types";
import MailChimp from "@/components/MailChimp/index.vue";
import filterValueInputType from "@/config/enumCode/inputType.js";
import operator from "@/config/enumCode/operator.js";
import { echoValueTypeConversion } from "@/config/filter/commaProcessing";
import { getMarketseaSwitchState } from "@/views/applicationProgram/api.js";

import Filterbutton from "./FilterButton";
import ViewToggle from "./ViewToggle";
import LayoutToggle from "./LayoutToggle";
import SearchWrapper from "./SearchWrapper";
import HotButton from "./HotButton";
import OtherButton from "./OtherButton";
import CustomButton from "./CustomButton";
import FilterPanel from "./FilterPanel";
import BatchButton from "./BatchButton";
import SelectSize from "./SelectSize";
import CreateEditView from "@/views/Create/CreateView";
import CreateEditObj from "@/views/commonObjects/components/create-edit-obj.vue";
import TablePanel from "./TablePanel";
import HighSeasPool from "@/components/ButtonAction/HighSeasPool";
// 客户端脚本
import {listClientScript, myOnLoad} from "@/utils/ccdk/clientScript.js";
// import FileSaver from 'file-saver'
// import XLSX from 'xlsx'

export default {
  name: "CommonTableList",
  mixins: [TransferOwnerMixin],
  components: {
    Filterbutton,
    HotButton,
    OtherButton,
    CustomButton,
    BatchButton,
    SelectSize,
    ViewToggle,
    LayoutToggle,
    FilterPanel,
    SearchWrapper,
    TablePanel,
    LabelView,
    Chart,
    Kanban,
    shiftPlan,
    addLabel,
    TransferOwnerDialog,
    MailChimp,
    CreateEditView,
    CreateEditObj,
    HighSeasPool,
  },
  data() {
    return {
      headerEditInfo:[],
      // 进入标准对象列表页第一次调用onload事件
      isOnload: true,
      // 是否是审批中记录二次删除
      isConfirmDel: "",
      // 是否显示打印、导出按钮
      isExportReport: false,
      // 跳转项目任务需要的参数
      projectTasksObjectApi: "",
      // 此对象包含的视图数量
      viewLength: 0,
      // 是否同时满足所有标签
      isAllTag: "",
      // 是否搜索所有
      isallsearch: "false",
      checkFlag: false,
      memberGroup: [],
      // 新建、编辑视图数据
      objForm: {},
      // 新建、编辑组件使用，标识是否是列表页编辑，编辑时保存不跳详情页
      isTableEdit: false,
      // 控制转移所有者变量
      transferClientOwnerDialog: false,
      // 控制table中的加载框
      pictLoading: false,
      // 存储精度的长度
      lengths: 0,
      // 视图新建权限
      createView: false,
      // 是否展示看板视图
      showKanban: false,
      // 是否展示轮班视图
      showPlan: false,
      // 是否显示筛选器
      showScreen: false,
      // 显示标签
      isLabelView: false,
      // 显示图表
      isChart: false,
      // 浏览器tab名称
      tabName: "",
      // 对象api
      objectApi: this.$route.params.objectApi,
      // 视图类型
      type: this.$route.params.type,
      // 对象id
      objId: this.$route.params.objId,
      // 对象前缀
      prefix: this.$route.params.prefix,
      // table表头
      tableAttr: null,
      // table操作按钮集合
      tableBtnList: {
        // 操作
        fixed: "right",
        title: this.$i18n.t("label.operate"),
        buttonList: [
          createButton({
            // 编辑
            label: this.$i18n.t("label.modify"),
            action: "edit",
          }),
          createButton({
            // 删除
            label: this.$i18n.t("label.delete"),
            action: "del",
          }),
          createButton({
            // 更改所有人
            label: this.$i18n.t("label_tabpage_cownerz"),
            action: "transferOwner",
          }),
        ],
      },
      // 页面对象，需要传递给table组件
      pageObj: {
        dataList: [],
      },
      // 控制删除数据dialog显隐
      dialogVisible: false,
      // 视图右侧按钮集合
      showBtns: [],
      // 视图列表中是否显示过滤框
      showFilter: false,
      // 布局类型集合：列表、看板、分屏
      viewsTypeList: [
        {
          icon: "List",
          name: this.$i18n.t("vue_label_help_list"),
        },
        {
          icon: "Kanban",
          name: this.$i18n.t("vue_label_commonobjects_view_kanban_view"),
        },
        {
          icon: "splitscreen",
          name: this.$i18n.t("vue_label_commonobjects_view_split_screen_view"),
        },
      ],
      // 需要右上角展示出来的按钮
      showButtons: [],
      // 需要右上角展示出来的自定义按钮
      showCustomButtons: [],
      // 视图名称
      viewName: "",
      // 视图Id
      viewId: this.$route.query.viewId,
      // 此对象包含的视图列表
      viewList: [],
      // 页码默认为1
      pageNum: 1,
      // 页码
      skippageNum: 1,
      // 每页展示数据条数
      pageSize: 50,
      // 总记录数
      totalSize: 0,
      // 有无数据标识
      noDataTip: false,
      // 排序字段
      sortField: "",
      // 排序字段名称
      sortFieldName: "",
      // 排序方式：正序、倒序
      sortDir: "asc",
      // 新建视图时，选择的字段集合
      viewSelectedFieldList: [],
      // 新建视图时，未选择的字段集合
      viewUnselectedFieldList: [],
      // 搜索关键字
      searchKeyWord: "",
      // 高级搜索的条件
      conditionValues: "",
      // 搜索标签
      tagIds: "",
      // 全局搜索是否只查询所有人是自己的记录
      myself: "false",
      // 全文检索查询返回值，下一页查询回传
      scrollId: "false",
      // 数据过滤搜索条件
      getViewListDataParams: {},
      // 编辑记录id
      id: "",
      // 是否开启表格单条数据更新，如果开启必须传记录id
      editFlag: false,
      // 新创建的视图Id
      newViewId: "",
      // 表格选中数据id
      ids: "",
      // 是否启用查找统计
      isQueryCount: false,
      // 视图信息
      viewInfo: {},
      // 表格选中数据集合
      selectedList: [],
      // 标记项目管理的新建按钮是否隐藏
      addable: "",
      // 对象对应的的报表列表
      reportList: [],
      // 报表列表的loading
      loadingReport: false,
      // 获取对象信息中的tag标记
      isTag: "",
      // 判断视图权限
      ismodifyFalg: "",
      // 对象下的仪表板列表
      listDashboard: [],
      // 仪表板列表loading
      loadingDashboard: false,
      // 看板数据
      kanBanData: null,
      // 看板tab值
      activeNames: null,
      // 是否支持单字段搜索标识
      exactSearchFlag: "",
      // 单字段搜索字段集合
      exactSearchFieldList: [],
      // 删除提示语
      delContent: "",
      // 导出链接
      daochuUrl: "",
      // 全选列表数据时存储的数据
      bool: null,
      // 按钮加载中
      isBtnLoading: false,
      // 当前筛选器数据
      curPushData: [],
      // 筛选器获取表头数据
      curHeader: [],
      // 按‘字段名’排序字段
      filterField: null,
      // 新建编辑视图弹窗
      dialongViewTo: false,
      // 新建视图时设置的视图名称
      title: "",
      // 视图标识
      viewcell: "",
      // 新建视图控制显隐变量
      visibFlag: false,
      // 新建时，选择的字段集合
      selectedFieldIds: "",
      // 新建时，选择的组集合
      selectedGroupList: [],
      checked: false,
      // 是否复制表单名字
      copyForm: {
        name: "",
      },

      isQueueSelect: false,
      // 是否应用于移动端
      isUsedForMobile: false,
      // 筛选框1下拉框数据
      optionst_one: [],
      // 筛选框2下拉框数据
      optionst_two: [],
      // 编辑视图时，队列选项值
      queryQueueValue: "",
      // 是否启用队列
      isQueue: null,
      // 队列列表
      queryQueueList: [],
      // 控制是否显示加载框
      loading: false,
      // 表单标签的宽度
      formLabelWidth: "138px",
      // 标记未选字段的长度
      selLength: 0,
      // 编辑或复制视图时用于保存Id
      enViewId: "",
      //存放当前对象是否开启公海池状态
      highSeaPoolStatus: {},
      //控制公海池弹框
      highSeasPdialog: false,
      // 视图自定义按钮
      customButtons: [],
      // 选中的自定义按钮
      checkCustomButtons: [],
    };
  },
  beforeRouteUpdate(to, from, next) {
    // mac笔记本手势左滑以及直接点击浏览器返回触发路由改变(不是通过点击TopMenu触发home中的clickshowMenu方法)
    // 会执行getViewList,此时store.state.objectList.tableListConfig中的viewId仍然是上一个对象的（切换了对象）
    // getViewListAjax这个接口使用上一个对象的视图id去请求当前对象的列表数据时，就会报错
    // 此处重置了viewId
    const isObjectChange = (to, from ) => to?.params?.objId !== from?.params?.objId
    // 通过路由直接切换时，判断是否是同一个对象
    if(isObjectChange(to, from)){
        const { prefix } = to.params
      this.$store.commit("setTableListConfig", Object.assign({},this.$store.state.objectList.tableListConfig, {
        prefix: prefix || '', // 视图id
        viewId: "", // 视图id
        pageSize: 25, // 每页条数
        skippageNum: 1, // 当前页数
        sortField: "", // 当前排序字段
        sortDir: "", // 当前排序顺序
      })); 
    }
    // 控制台视图页、标准视图页是一个路由，加了缓存  通过router-view的key更新数据即可  不需要走这里更新了  走这里会造成缓存path与页面对不上的问题
    this.conditionValues = ""; //切换视图时清空高级筛选条件
    this.curPushData = []; //切换视图时清空原有筛选条件
    this.viewId = to.query.viewId;
    this.type = to.params.type;
    this.objectApi = to.params.objectApi;
    this.objId = to.params.objId;
    this.prefix = to.params.prefix;
    this.totalSize = 0;
    this.pageNum = 1;
    this.skippageNum = 1;
    this.pageObj.dataList = [];
    this.sortField = "";
    this.sortFieldName = "";
    this.searchKeyWord = "";
    this.exactSearchFlag = "";
    // this.$refs.searchWrapper.exactSearchFlag为props，直接改变this.exactSearchFlag
    // this.$refs.searchWrapper.exactSearchFlag = "";
    this.transferClientOwnerDialog = false;
    this.reportList = []; // 清空报表列表
    this.listDashboard = []; // 清空仪表板列表
    // 给pageSize赋初始值
    // this.pageSize = 50;//切换菜单每页条数保留
    this.$store.commit("setPageSize", 0);
    this.$refs.searchWrapper.search = "";
    if (this.$refs.tablePanel && this.$refs.tablePanel.checkedList) {
      this.$refs.tablePanel.checkedList = [];
    }
    // 判断展示表格、看板或者计划轮班视图
    if (this.type === "table") {
      this.showKanban = false;
      this.showPlan = false;
      if (this.$refs.pullRight) {
        this.$refs.pullRight.isBoardView = false;
      }
    } else if (this.type === "kanban") {
      this.showKanban = true;
      this.showPlan = false;
      this.exactSearchFlag = "0";
    } else if (this.type === "plan") {
      this.showKanban = false;
      this.showPlan = true;
    }

    // 同一对象下切换列表视图和看板视图时不刷新视图列表
    if (
      to.params.prefix !== from.params.prefix ||
      (this.type === "table" && this.viewId === undefined)
    ) {
      this.getViewList(true);
    } else if (this.type === "table") {
      this.getViewListRecently();
      this.getViewListHeader();
      this.getViewListData();
      this.getObjectGetObjectInfos();
    }
    next();
    this.business(); // 控制按钮权限
  },
  created() {
    // 判断展示表格、看板或者计划轮班视图
    if (this.type === "table") {
      this.showKanban = false;
      this.showPlan = false;
    } else if (this.type === "kanban") {
      this.showKanban = true;
      this.showPlan = false;
    } else if (this.type === "plan") {
      this.showKanban = false;
      this.showPlan = true;
    }
    this.objId = this.$route.params.objId;
    this.prefix = this.$route.params.prefix;
    this.getViewList(true);
    this.getCreateView();
    this.checkQueueAndPartners();
  },
  mounted() {
    this.$store.commit("setObjIds", this.objId);

  },
  methods: {
    updateViewList(data){
      this.viewList = data
    },
    updateDefaultView(id){
        this.viewList.forEach(item => item.isdefault = item.id === id ? '1' : '0')
    },
    /**
     * 客户端脚本onload事件
     * 1、当存在this.objid时调用
     * 2、同一个对象只调用一次
     */
    listMyOnload(){
      if(this.objId && this.isOnload){
        let loadParam ={
          pageId: 'list',
          event: 'onLoad',
          objId: this.objId,
          recordTypeId: '',
        }
        listClientScript(loadParam,myOnLoad)
        this.isOnload=false
      }

    },
     /**
     * 批量删除数据后刷新(子组件通过$parent调用)
     */
    refreshAfterBatchDelete() {
      // 重置列表信息
      this.pageObj.dataList = [];
      this.pageNum = 1;
      this.skippageNum = 1;
      // 重置列表选中统计数据
      if (this.$refs.tablePanel) {
        this.$refs.tablePanel.checkedList = [];
      }
      this.getViewListData();
    },

    /**
     * 获取视图新建权限，当拥有创建权限时，需要显示复制按钮
     */
    getCreateView() {
      CommonObjApi.getUserSetup().then((res) => {
        this.createView = res.data.isCreateView === "true";
      });
    },
    /**
     * 获取视图Id
     * @param {String} n:创建新的视图id
     */
    getViewId(n) {
      this.newViewId = n;
      if (n) {
        this.getNewViewList();
      }
    },
    /**
     *  取消列表批量操作
     */
    cancelBatchOperation() {
      this.$refs.tablePanel.cancelAllchecked();
      this.ids = "";
      this.selectedList = [];
    },
    /**
     * 点击报表，在选项卡菜单页面根据对象id获取报表列表
     */
    async reportBoard() {
      // 若是当前报表列表为空，则请求接口获取该对象下的报表列表
      if (this.reportList.length === 0) {
        this.loadingReport = true;
        let params = {
          id: this.objId, // 对象Id
        };
        let { data } = await CommonObjApi.getReportListByObjId(params);
        this.reportList = data;
        this.loadingReport = false;
      }
    },
    /**
     * 获取视图列表，当设置默认视图时，只刷新GetViewList，不刷新表格数据
     * 1、支持路由中携带viewId，展示指定视图数据，需要判断this.$route.query.viewId是否有值
     * @param {Boolean} viewFlag 是否刷新表格数据 
     */
    getViewList(viewFlag) {
      this.viewName = "";
      if (this.$store.state.objectList.tableListConfig) {
        let applicationTab = sessionStorage.getItem("applicationTab");
        let config = this.$store.state.objectList.tableListConfig;
        if (applicationTab === config.applicationId) {
          this.viewId = this.$route.query.viewId || config.viewId; // 视图id
          this.pageSize = config.pageSize; // 每页条数
          this.skippageNum = config.skippageNum; // 当前页数
          this.sortField = config.sortField; // 当前排序字段
          this.sortDir = config.sortField === "" ? "" : config.sortDir; // 当前排序顺序
        } else {
          this.viewId = this.$route.query.viewId || "";
          this.pageSize = 50; // 每页条数
          this.skippageNum = 1; // 当前页数
          this.pageNum = 1; // 当前页数
          this.sortField = ""; // 当前排序字段
          this.sortDir = ""; // 当前排序顺序
          this.cacheListData();
        }
      } else {
        this.viewId = this.$route.query.viewId || ""; // 视图id
      }
      CommonObjApi.getDefaultViewList({ objId: this.objId }).then((res) => {
        const temp = {
          ...res.data,
          isCurrent: true
        }
        if (!this.viewId) {
          this.viewName = temp.label;
          this.viewId = temp.id;
          this.viewInfo = temp;
        }

        if (viewFlag) {
           if (this.viewId) {
            // 存在viewId显示指定视图
            if (this.viewList?.length == 0) {
              CommonObjApi.GetViewList({ objId: this.objId }).then((res) => {
                this.viewList = res.data;
                this.viewList.map((item) => {
                  // 获取当前视图信息
                  if (item.id === this.viewId) {
                    this.viewName = item.label;
                    item.isCurrent = true;
                    this.viewInfo = item;
                    this.ismodifyFalg = item.ismodify;
                  } else {
                    item.isCurrent = false;
                  }
                });
              });
            }
          }
          this.getViewListRecently();
          this.getViewListHeader();
          this.getViewListData();
          this.getObjectGetObjectInfos();
        }
       

        
        // 如果为轮班视图，且为不可编辑的视图，展示列表
        if (
          this.type === "plan" &&
          this.ismodifyFalg !== "true" &&
          (this.viewId === "0" ||
            this.viewId === "1" ||
            this.viewId === "2" ||
            this.viewId === "3")
        ) {
          this.tableView();
        }
      })
      // CommonObjApi.GetViewList({ objId: this.objId }).then((res) => {
      //   this.viewList = res.data;
      //   this.viewList.map((item) => {
      //     // 获取列表视图/看板视图带过来的视图信息
      //     if (item.id === this.viewId) {
      //       item.isCurrent = true;
      //       this.viewName = item.label;
      //       this.viewInfo = item;
      //       this.ismodifyFalg = item.ismodify;
      //       this.business();
      //     } else {
      //       item.isCurrent = false;
      //     }
      //   });

      //   if (this.viewName === "" &&!this.$route.query.viewId ) {
      //     this.viewList.map((item) => {
      //       // 获取默认视图信息
      //       if (item.isdefault === "1") {
      //         this.viewName = item.label;
      //         this.viewId = item.id;
      //         this.viewInfo = item;
      //         this.ismodifyFalg = item.ismodify;
      //         this.business();
      //       } else {
      //         item.isCurrent = false;
      //       }
      //     });
      //   }

      //   // 若接口返回视图列表无默认视图，将第一个视图作为显示视图
      //   if (this.viewName === "" && !this.$route.query.viewId) {
      //     this.viewList[0].isCurrent = true;
      //     this.viewName = this.viewList[0].label;
      //     this.viewId = this.viewList[0].id;
      //     this.viewInfo = this.viewList[0];
      //     this.ismodifyFalg = this.viewList[0].ismodify;
      //     this.business();
      //   }
      //   this.viewLength = this.viewList.length;
      //   if (viewFlag) {
      //     this.getViewListRecently();
      //     this.getViewListHeader();
      //     this.getViewListData();
      //     this.getObjectGetObjectInfos();
      //   }
      //   // 如果为轮班视图，且为不可编辑的视图，展示列表
      //   if (
      //     this.type === "plan" &&
      //     this.ismodifyFalg !== "true" &&
      //     (this.viewId === "0" ||
      //       this.viewId === "1" ||
      //       this.viewId === "2" ||
      //       this.viewId === "3")
      //   ) {
      //     this.tableView();
      //   }
      // });
    },
    /**
     * 编辑、新建视图
     * @param {String} valArr 视图对象
     */
    handleView(valArr) {
      let opration = valArr[0];
      // 新建视图
      if (opration == "create") {
        this.newlyBuild();
      }
      // 编辑视图
      else if (opration == "edit") {
        this.enViewId = valArr[1].id;
        this.editBuild();
      }
      // 复制视图
      else if (opration == "copy") {
        this.$refs.createEditView.copySave(opration);
      }
    },

    /**
     * 初始化数据
     */
    init() {
      this.objForm = {
        label: "",
        filter: "", //高级筛选值
        screeRadio: "0",
        visibRadio: "fsharenone",
        createbyidccname: "", //创建人
        createdate: "", //创建时间
        lastmodifybyidccname: "", //最后修改人
        lastmodifydate: "", //最后修改时间
        list: [
          {
            fieldId: "",
            op: "",
            val: {
              value: "",
            },
            type: 1,
            id: 1,
            inputType: "input",
            optionst_two: [],
            objid: "",
          },
        ],
      };
    },

    /**
     * 新建视图
     */
    newlyBuild() {
      this.viewUnselectedFieldList = [];
      // 新建视图
      this.title = this.$i18n.t("vue_label_commonobjects_view_new_view");
      this.dialongViewTo = true;
      this.viewcell = "creatededit";
      this.visibFlag = false;
      this.selectedFieldIds = "";
      this.selectedGroupList = [];
      this.init();
      this.$nextTick(() => {
        if (this.$refs.createEditView.$refs.oneShuttle !== undefined) {
          this.$refs.createEditView.$refs.oneShuttle.searchVal = "";
        }
        if (this.$refs.createEditView.$refs.shuttles !== undefined) {
          this.$refs.createEditView.$refs.shuttles.searchVal = "";
        }
      });
      this.getViewInfo();
    },

    /**
     * 编辑视图
     */
    editBuild() {
      this.title = this.$i18n.t("label.view.introduce");
      this.viewcell = "creatededit";
      this.init();
      this.objForm.filter = "";
      this.dialongViewTo = true;
      this.getViewInfo();
      this.$nextTick(() => {
        if (
          this.$refs.createEditView.$refs.oneShuttle ||
          this.$refs.createEditView.$refs.shuttles
        ) {
          this.$refs.createEditView.$refs.oneShuttle.searchVal = "";
          this.$refs.createEditView.$refs.shuttles.searchVal = "";
        }
      });
    },

    /**
     * 复制视图
     */
    openCopyView(val) {
      this.enViewId = val;
      this.title = this.$i18n.t("vue_label_commonobjects_view_copy_view");
      this.init();
      this.getViewInfo();
    },

    /**
     * 关闭视图
     */
    closeViewDialog() {
      this.$refs.chooseviewRef.dialogSign = false;
      this.dialongViewTo = false;
    },

    /**
     * 获取视图详细信息
     */
    getViewInfo() {
      // 先做清空
      this.objForm.list = [
        {
          fieldId: "",
          op: "",
          val: {
            value: "",
          },
          type: 1,
          id: 1,
          inputType: "input",
          optionst_two: [],
          objid: "",
        },
      ];
      this.objForm.filter = "";
      this.checkFlag = false;
      this.checked = false;
      const params = {
        //新建时viewid传""
        viewId:
          this.title === this.$i18n.t("vue_label_commonobjects_view_new_view")
            ? ""
            : this.enViewId,
        objId: this.objId,
      };
      this.loading = true;
      CommonObjApi.GetViewInfo(params).then((res) => {
        // if (this.title === "编辑视图" || this.title === "复制视图") {
        if (
          this.title === this.$i18n.t("label.view.introduce") ||
          this.title === this.$i18n.t("vue_label_commonobjects_view_copy_view")
        ) {
          if (res.data.viewInfo) {
            let viewInfoList = res.data.viewInfo;
            //判断是否是复制视图名字
            if (
              this.title ===
              this.$i18n.t("vue_label_commonobjects_view_copy_view")
            ) {
              this.copyForm.name =
                viewInfoList.label + this.$i18n.t("vue_label_norm_duplicate");
            } else {
              this.copyForm.name = "";
            }
            /**
             * 筛选条件所有人
             * @param {String} filter
             * "0" 全部
             * "1" 我的
             * "一串id" 队列 (用于回显队列下拉框的值)
             */
            if (viewInfoList.filter !== "0" && viewInfoList.filter !== "1") {
              this.isQueueSelect = true;
              this.queryQueueValue = viewInfoList.filter;
              this.objForm.screeRadio = "2"; // 显示队列要设置"2"
            } else {
              this.isQueueSelect = false;
              this.objForm.screeRadio = viewInfoList.filter;
            }

            //名称
            this.objForm.label = viewInfoList.label;
            //高级筛选表单值
            if (
              res.data.conditionSelectedFieldList &&
              res.data.conditionSelectedFieldList[0] &&
              res.data.conditionSelectedFieldList[0].boolfilter
            ) {
              this.objForm.filter =
                res.data.conditionSelectedFieldList[0].boolfilter;
              this.checkFlag = true;
              this.checked = true;
            } else {
              this.objForm.filter = "";
              this.checkFlag = false;
              this.checked = false;
            }
            //创建人和修改人
            this.objForm.createbyidccname = viewInfoList.createbyidccname;
            this.objForm.createdate = viewInfoList.createdate;
            this.objForm.lastmodifydate = viewInfoList.lastmodifydate;
            this.objForm.lastmodifybyidccname =
              viewInfoList.lastmodifybyidccname;
            if (viewInfoList.isusedformobile === "true") {
              this.isUsedForMobile = true;
            } else {
              this.isUsedForMobile = false;
            }
            //可见性
            if (viewInfoList.accesstype == "fsharegroups") {
              this.objForm.visibRadio = "fsharegroups";
              this.visibFlag = true;
              this.selectedGroupList = res.data.selectedGroupList;
            } else if (viewInfoList.accesstype == "fshareall") {
              this.objForm.visibRadio = "fshareall";
              this.visibFlag = false;
            } else if (viewInfoList.accesstype == "fsharenone") {
              this.objForm.visibRadio = "fsharenone";
              this.visibFlag = false;
            }
          }
          //已选字段
          if (res.data.viewSelectedFieldList) {
            this.viewSelectedFieldList = res.data.viewSelectedFieldList;
            let selecteArr = [];
            res.data.viewSelectedFieldList.forEach((val) => {
              selecteArr.push(val.id);
            });
            this.selectedFieldIds = selecteArr.join(",");
          }
          // 自定义按钮
          this.customButtons = res.data.buttonlist || [];
          if (
            res.data.viewInfo.viewButtons &&
            res.data.viewInfo.viewButtons.length > 0
          ) {
            let arr = [];
            res.data.viewInfo.viewButtons.forEach((item) => {
              arr.push(item.buttonId);
            });
            this.checkCustomButtons = arr;
          } else {
            let arr = [];
            res.data.buttonlist &&
              res.data.buttonlist.forEach((item) => {
                arr.push(item.id);
              });
            this.checkCustomButtons = arr;
          }
          //已选成员
          const selectedMembList = res.data.selectedGroupList;
          if (selectedMembList) {
            let newArr = [];
            selectedMembList.forEach((val) => {
              newArr.push(val.id);
            });
            this.memberGroup = newArr.join(",");
          }
          //筛选字段下拉框数据
          this.optionst_one = res.data.conditionAllFieldList;
          // 运算符下拉初始化加载
          if (res.data.conditionSelectedFieldList.length) {
            let arr = [];
            res.data.conditionSelectedFieldList.map((item) => {
              this.optionst_one.map((itm) => {
                if (item.fieldId === itm.id) {
                  let inputType =
                    filterValueInputType[
                      itm.schemefieldType === "L" || itm.schemefieldType === "R"
                        ? "Q"
                        : itm.schemefieldType
                    ];
                  // 选择框类型为查找多选字段时，才需要回显做处理
                  if (inputType === "multi-select") {
                    item.val = echoValueTypeConversion(item.val);
                  }
                  arr.push({
                    fieldId: item.fieldId,
                    op: item.op,
                    seq: item.seq,
                    val: {
                      value: item.val,
                    },
                    inputType: inputType,
                    type:
                      itm.schemefieldType === "Z"
                        ? itm.expressionType
                        : itm.schemefieldType,
                    optionst_two:
                      operator.TYPE[
                        itm.schemefieldType === "Z"
                          ? itm.expressionType
                          : itm.schemefieldType
                      ].getScreeningOpeTypes(),
                  });
                }
              });
            });
            // 需要响应式添加
            this.objForm.list = arr;
            // this.$set(this.objForm,'list',arr)
          } else {
            this.objForm.list = [
              {
                fieldId: "",
                op: "",
                val: {
                  value: "",
                },
                type: 1,
                id: 1,
                inputType: "input",
                optionst_two: [],
                objid: "",
              },
            ];
          }
        } else {
          // 自定义按钮
          this.customButtons = res.data.buttonlist || [];
          if (res.data.viewInfo?.viewButtons?.length > 0) {
            let arr = [];
            res.data.viewInfo.viewButtons.forEach((item) => {
              arr.push(item.buttonId);
            });
            this.checkCustomButtons = arr;
          } else {
            let arr = [];
            res.data.buttonlist &&
              res.data.buttonlist.forEach((item) => {
                arr.push(item.id);
              });
            this.checkCustomButtons = arr;
          }
        }
        //筛选字段下拉框数据
        this.optionst_one = res.data.conditionAllFieldList;
        /*
          新建视图：已选字段设置默认为name字段；
          编辑、复制视图：直接取返回的已选字段即可。
        */
        if (
          this.title === this.$i18n.t("vue_label_commonobjects_view_new_view")
        ) {
          //已选字段
          this.viewSelectedFieldList = res.data.viewUnselectedFieldList.filter(
            (itemVal) => {
              return itemVal.name === "name";
            }
          );
          //未选字段
          this.viewUnselectedFieldList =
            res.data.viewUnselectedFieldList.filter((itemVal) => {
              return itemVal.name !== "name";
            });
          this.selLength = this.viewUnselectedFieldList.length;
        } else {
          //未选字段
          this.viewUnselectedFieldList = res.data.viewUnselectedFieldList;
          this.selLength = this.viewUnselectedFieldList.length;
          //已选字段
          if (res.data.viewSelectedFieldList) {
            this.viewSelectedFieldList = res.data.viewSelectedFieldList;
          }
        }
        this.loading = false;
      });
    },

    /**
     * 获取视图列表
     * 新建视图保存后刷新视图列表，将新建视图设置为当前视图
     */
    getNewViewList() {
      this.viewName = "";
      CommonObjApi.GetViewList({
        objId: this.objId,
      }).then((res) => {
        this.viewList = res.data;
        this.viewList.map((item) => {
          // 获取当前视图信息
          if (item.id === this.newViewId) {
            item.isCurrent = true;
            this.viewName = item.label;
            this.viewInfo = item;
            this.ismodifyFalg = item.ismodify;
          } else {
            item.isCurrent = false;
          }
        });
        if (this.viewName === "") {
          this.viewList.map((item) => {
            // 获取默认视图信息
            if (item.isdefault === "1") {
              item.isCurrent = true;
              this.viewName = item.label;
              this.viewId = item.id;
              this.ismodifyFalg = item.ismodify;
              this.viewInfo = item;
            } else {
              item.isCurrent = false;
            }
          });
        } else {
          this.viewId = this.newViewId;
        }

        // 若接口返回视图列表无默认视图，将第一个视图作为显示视图
        if (this.viewName === "") {
          this.viewList[0].isCurrent = true;
          this.viewName = this.viewList[0].label;
          this.viewId = this.viewList[0].id;
          this.viewInfo = this.viewList[0];
          this.ismodifyFalg = this.viewList[0].ismodify;
        }

        this.viewLength = this.viewList.length;
        this.pageNum = 1;
        this.skippageNum = 1;
        this.getViewListRecently();
        this.getViewListHeader();
        this.getViewListData();
        this.changeView(this.viewInfo);
        this.getObjectGetObjectInfos();
      });
    },
    /**
     * 更新选中的自定义按钮
     */
    updateCheckCustomBtns(val) {
      this.checkCustomButtons = val;
    },
    /**
     * 获取视图列表按钮权限
     */
    getViewListRecently() {
      this.exactSearchFlag = "";
      this.exactSearchFieldList = [];
      // document.getElementsByClassName("left-content")[0].style.width = "300px"; //影响页面布局出现大量空白注释掉

      CommonObjApi.getViewListRecently({
        obj: this.prefix,
        viewId: this.viewId,
      }).then((res) => {
        if (res.data) {
          document.title = this.$setTitle(
            `${res.data.viewName} | ${res.data.label}`
          );
          this.tabName = res.data.label;
          this.exactSearchFlag = res.data.exactSearchFlag || "";
          this.exactSearchFlag =
            this.type === "kanban" ? "0" : this.exactSearchFlag;
          this.exactSearchFieldList = res.data.exactSearchFieldList || [];
          this.$store.commit(types.SET_TAB_NAME, this.tabName);

          if (this.prefix === "001") {
            this.tableBtnList.buttonList.splice(
              2,
              1,
              createButton({
                // 更改所有人
                label: this.$i18n.t("label_tabpage_cownerz"),
                action: "transferClientOwner",
              })
            );
          } else {
            this.tableBtnList.buttonList.splice(
              2,
              1,
              //转移所有人
              createButton({
                label: this.$i18n.t("label_tabpage_cownerz"),
                action: "transferOwner",
              })
            );
          }
          // 预计人工成本、实际人工成本不展示操作列
          if (
            this.$cookies.get("activeTabObjId") === "cloudccPlanCost" ||
            this.$cookies.get("activeTabObjId") === "cloudccRealCost"
          ) {
            this.tableBtnList.buttonList = [];
          }
          // 是否启用查找统计
          this.isQueryCount = res.data.isQueryCount;
          this.showBtns = res.data.listBtn.concat(res.data.toolsBtn);
          // 判断是否有导出、打印权限（走导出报表权限）
          this.isExportReport = res.data.isExportReport === "true";
          if (this.isExportReport) {
            // 添加导出、打印按钮
            this.business();
          }
          res.data.viewButtonlist?.forEach((item) => {
            item.category = "CustomButton";
          });
          let data=res.data.viewButtonlist || [];
          this.showCustomButtons = data.map(item=>{
            return {
              ...item,
              /**
               * 王惠清说这里要用 labelname_lang 才对，才是翻译后的词条
               */
              label:item.labelname_lang
            }
          })
        }
      });
    },
    /**
     * 获取视图详细信息
     */
    searchViewDetail() {
      if (
        !(
          (this.viewId === "0" ||
            this.viewId === "1" ||
            this.viewId === "2" ||
            this.viewId === "3") &&
          this.ismodifyFalg !== "true"
        )
      ) {
        this.getFieldSetup();
      }
    },
    /**
     * 保存视图选中字段
     * @param {Array} ids 字段集合
     */
    saveSelectedField(ids) {
      CommonObjApi.saveFieldSetup({
        objId: this.objId,
        viewId: this.viewId,
        fieldIds: ids,
      }).then(() => {
        this.pageNum = 1;
        this.skippageNum = 1;
        this.getViewListHeader();
        this.getViewListData();
        this.$message.success(this.$i18n.t("label.search.saveok"));
      });
    },
    /**
     * 获取视图详细信息
     */
    getFieldSetup() {
      this.viewSelectedFieldList = [];
      this.viewUnselectedFieldList = [];
      CommonObjApi.getFieldSetup({
        objId: this.objId,
        viewId: this.viewId,
      }).then((res) => {
        this.viewSelectedFieldList = res.data.viewSelectedFieldList;
        this.viewUnselectedFieldList = res.data.viewUnselectedFieldList;
      });
    },
    /**
     * 获取视图列表表头
     */
    getViewListHeader() {
      this.showScreen = false;
      this.isLabelView = false;
      this.isChart = false;
      // this.pictLoading = true;
      this.tableAttr = [];
      let params = {
        obj: this.prefix,
        viewId: this.viewId,
        tagIds: this.tagIds,
        isAllTag: this.isAllTag,
        searchKeyWord: this.searchKeyWord,
        conditionValues: this.conditionValues,
      };
      CommonObjApi.getListHeaderInfo(params).then((res)=>{
        CommonObjApi.getListHeaderEditInfo({
          obj: this.prefix,
          fieldIds: res.data.headLabel.reduce((prev,next)=>{
            return prev + (prev ? ',' : '' ) + next.id
          }, '')
        }).then((headerEditInfo) => {
          this.headerEditInfo = headerEditInfo.data.headLabel
        })
      // })
      // CommonObjApi.getViewListHeader(params).then((res) => {
        this.curHeader = res; //高级筛选器传参
        // 打印数据存储到vuex
        this.$nextTick(() => {
          //解决第一次触发emit无效问题
          this.$store.state.printHeard = this.tableAttr;
        });
        if (
          this.objId === "cloudccPlanCost" ||
          this.objId === "cloudccRealCost"
        ) {
          //项目管理中（实际人工成本和预计人工成本）隐藏新建按钮
          this.addable = false;
        } else {
          // this.addable = res.data.objServices.add;
          this.addable = false
        }
        this.tableAttr = res.data.headLabel;
        this.tableAttr.forEach((item, idx) => {
          item.sortAsc = false;
          item.sortDesc = false;
          item.filterScreen = false;
          item.popWidth = (item.nameLabel.length + 6) * 15;
          // 名称、查找、主详、查找多选均可跳转
          // 事件及任务下的主题、名称、相关项可跳转
          if (
            item.schemefieldName === "name" ||
            item.schemefieldType === "Y" ||
            item.schemefieldType === "M" ||
            item.schemefieldType === "MR" ||
            item.schemefieldName === "subject" ||
            item.lookupObj === "user" ||
            item.schemefieldName === "whoid" ||
            item.schemefieldName === "relateid"
          ) {
            this.$set(this.tableAttr[idx], "click", "detail");
          }

          // 项目管理-实际工作清单点击日期跳转详情
          if (this.$cookies.get("activeTabObjId") === "projectworklist") {
            if (item.schemefieldType === "D") {
              this.$set(this.tableAttr[idx], "click", "detail");
            }
          }
          this.$set(this.tableAttr[idx], "sortByThis", false);
          this.$set(this.tableAttr[idx], "sortDir", "asc");
          this.$set(this.tableAttr[idx], "fixed", false);
          this.$set(this.tableAttr[idx], "locked", false);
        });
        this.$refs.tablePanel &&
          this.$refs.tablePanel.changeTableAttr(this.tableAttr);
        // setTimeout(() => {
        //   this.pictLoading = false;
        // }, 1000);
      });
    },
    /**
     * 刷新
     * @param {String} id 看板id
     */
    refresh(id) {
      this.$refs.kanban && this.$refs.kanban.GetViewKanbanDisplays("", id);
      this.sortField = "";
      this.sortFieldName = "";
      // 重置列表信息
      this.pageObj.dataList = [];
      this.pageNum = 1;
      this.skippageNum = 1;
      this.tagIds = "";
      // 重置列表选中统计数据
      if (this.$refs.tablePanel) {
        this.$refs.tablePanel.checkedList = [];
      }
      this.getViewListHeader();
      this.getViewListData();
    },
    /**
     * 搜索条件改变
     * @param {String} val 搜索内容
     */
    changeKeyWord(val) {
      if (this.$route.params.type === "kanban") {
        this.GetViewKanbanDisplays(val);
      } else if (this.$route.params.type === "plan") {
        // 如果是轮班视图
        this.$refs.shiftPlan.handleSearch(val);
      } else {
        this.pageNum = 1;
        this.skippageNum = 1;
        this.searchKeyWord = val;
        // 特殊视图搜索条件改变时刷新表头
        if (
          this.viewId === "0" ||
          this.viewId === "1" ||
          this.viewId === "2" ||
          this.viewId === "3"
        ) {
          this.getViewListHeader();
        }
        // 清空列表选中数据
        if (this.$refs.tablePanel && this.$refs.tablePanel.checkedList) {
          this.$refs.tablePanel.checkedList = [];
        }
        this.getViewListData();
      }
    },
    /**
     * 缓存列表数据
     */
    cacheListData() {
      let tableListConfig = {
        prefix: this.prefix, // 视图id
        viewId: this.viewId, // 视图id
        pageSize: this.pageSize, // 每页条数
        skippageNum: this.skippageNum, // 当前页数
        applicationId: sessionStorage.getItem("applicationTab"), // 应用id
        sortField: this.sortField, // 当前排序字段
        sortDir: this.sortField === "" ? "" : this.sortDir, // 当前排序顺序
      };
      this.$store.commit("setTableListConfig", tableListConfig); // 存储列表条件
    },

    /**
     * 获取视图数据
     * @param {Object||String} val 查询条件,标识是否是切换分页重新获取数据，如果val为'noClearn',标识是分页后重新获取数据，此时不需要清空表格选中的数据
     */
    getViewListData(val) {
      if (this.viewId) {
        /**
         * 参数说明
         * 参数名	必选	类型	说明
         * obj	是	string	对象前缀
         * viewId	是	string	视图Id
         * pageNum	是	string	页数
         * pageSize	是	string	每页数量
         * sortField	是	string	排序字段apiname(schemefieldName)
         * sortDir	是	string	排序类型(desc[降序]/asc[升序])
         * searchKeyWord	是	string	搜索关键字
         * conditionValues	是	string	高级搜索条件
         * ischangenum	是	string	是否修改每页查询数目（修改的数目为视图默认每页数量）
         * recordnums	是	string	每页查询默认数目
         * tagIds	否	string	标签id，多个标签逗号分隔，按选中标签查询
         * isAllTag	否	string	是否同时满足所有选中标签（true/false）
         * campaignid	否	string	市场活动成员是否只查询现有成员
         * isallsearch	否	string	是否启用启用全局搜索，conditionValues不用空也不启用全局搜索
         * myself	否	string	全局搜索是否只查询所有人是自己的记录
         * scrollId	否	string	全文检索查询返回值，下一页查询回传
         * type	否	string	contact/lead特殊查询使用以不使用全文检索，参数暂时不用
         */
        this.noDataTip = false;
        if (val && val == "sort") {
          this.$refs.tablePanel.openFullScreen();
        } else {
         this.pageNum!== 1 && (this.pictLoading = true);
        }
        this.cacheListData();
        this.getViewListDataParams = {
          obj: this.prefix,
          viewId: this.viewId,
          pageNum: this.skippageNum, //Y  分页页码
          pageSize: this.pageSize,
          sortField: this.sortField,
          sortDir: this.sortField === "" ? "" : this.sortDir,
          searchKeyWord: this.searchKeyWord,
          conditionValues: this.conditionValues,
          ischangenum: "false",
          recordnums: this.pageSize,
          tagIds: this.tagIds,
          isAllTag: this.isAllTag,
          campaignid: "false",
          isallsearch: this.isallsearch,
          myself: this.myself,
          scrollId: this.scrollId,
          type: "",
          exactSearchFlag: this.exactSearchFlag,
        };
        CommonObjApi.getViewListData(this.getViewListDataParams).then((res) => {
          this.daochuUrl = res.data.exportUrl;
          if (res.result && res.returnCode === "1") {
            /**
             * 分页
             */
            if (res.data.list.length === 0 && this.pageNum === 1) {
              this.pageObj.dataList = [];
              this.pageNum++;
            } else {
              // 此时应该处理些数据，避免在表格组件中处理数据

              res.data.list.forEach((item) => {
                // 便于cell a标签href使用
                item.nameHrefUrl = `javascript:void(0);`;
                // 给标签添加id
                if (item.cloudcctagList) {
                  item.cloudcctagList.forEach((tagItem, tagIndex) => {
                    tagItem.id = tagIndex + Date.now() + Math.random();
                  });
                }
              });
              this.pageObj.dataList = res.data.list;

              /**
               * 非切换页码或者 *条/页 的时候表格选中数据清除
               */
              if (this.$refs.tablePanel && val !== "noClearn") {
                this.$refs.tablePanel.checkedList = [];
              }
              this.pageNum++;
            }

            // 判断是否有总数
            if (res.data.isQueryCount === "true") {
              this.totalSize = res.data.totalSize;
            } else {
              //判断还有没有下一页
              if (res.data.haveMore === "true") {
                //如果有根据页码和每页的数量计算总数
                this.totalSize = (this.skippageNum + 1) * this.pageSize;
                //如果没有下一页
              } else if (
                res.data.haveMore === "false" &&
                this.skippageNum == 1
              ) {
                this.totalSize = res.data.totalSize;
              }
            }
            if (val && val == "sort") {
              this.$refs.tablePanel.closeFullScreen();
            } else {
              setTimeout(() => {
                this.pictLoading = false;
              }, 1000);
            }
            // setTimeout(() => {
            //   this.$refs.tablePanel &&
            //     this.$refs.tablePanel.$refs.tablePanel &&
            //     this.$refs.tablePanel.$refs.tablePanel.doLayout();
            // }, 2000);
            this.pageObj.totalSize = res.data.totalSize;
          } else {
            this.$message.error(res.returnInfo);
          }
          this.$nextTick(()=>{
            // 客户端脚本onload事件
            this.listMyOnload()
          })
        });
      }
    },
    /**
     * 判断路由是否存在viewId
     * @param {String} view 视图Id
     */
    judgeViewId(view) {
      if (this.$route.query.viewId) {
        let query = this.$router.history.current.query;
        let path = this.$router.history.current.path;
        //对象的拷贝
        let newQuery = JSON.parse(JSON.stringify(query));
        newQuery.viewId = view.id;
        this.$router.replace({ path, query: newQuery });
      }
    },
    /**
     * 切换视图
     * @param {String} view 视图Id
     */
    changeView(view) {
      this.judgeViewId(view);
      this.searchKeyWord = "";
      this.exactSearchFlag = "";
      this.exactSearchFieldList = [];
      this.$refs.searchWrapper.searchKeyWord = "";
      this.$refs.searchWrapper.search = ""; //切换视图时清空搜索关键字
      this.conditionValues = ""; //切换视图时清空高级筛选条件
      this.curPushData = []; //切换视图时清空原有筛选条件
      this.viewList.map((item) => {
        // 获取默认视图信息
        if (item.id === view.id) {
          this.viewName = item.label;
          this.viewId = item.id;
          item.isCurrent = true;
          this.ismodifyFalg = item.ismodify;
          this.viewInfo = item;
          this.business();
        } else {
          item.isCurrent = false;
        }
      });

      // 如果为轮班视图，且为不可编辑的视图，展示列表
      if (
        this.type === "plan" &&
        this.ismodifyFalg !== "true" &&
        (this.viewId === "0" ||
          this.viewId === "1" ||
          this.viewId === "2" ||
          this.viewId === "3")
      ) {
        this.tableView();
      } else if (this.type === "plan") {
        this.$refs.shiftPlan.handleView();
      } else if (
        this.ismodifyFalg !== "true" &&
        (this.viewId === "0" ||
          this.viewId === "1" ||
          this.viewId === "2" ||
          this.viewId === "3")
      ) {
        this.tableView();
      }
      // 刷新视图列表
      // this.viewId=view.id
      this.refresh(view.id);
      this.getViewListRecently();
      this.getObjectGetObjectInfos();
    },
    /**
     * 新建
     */
    add() {
      this.id = "";
      if (this.objId === "appointment") {
        this.$router.push({
          path: "/scheduleappointment/bookingdetails",
        });
      } else {
        this.isTableEdit = false;
        this.$refs.createEditObj.add();
      }
    },
    /**
     * 编辑
     */
    edit(row) {
      this.id = row.data.id;
      if (this.objId === "appointment") {
        this.$router.push({
          path: "/scheduleappointment/bookingdetails",
          query: {
            id: row.data.id,
          },
        });
      } else {
        // 联系人列表"编辑"(个人客户生成的联系人)
        if(row.data.ispersonaccount &&
           row.data.ispersonaccount === "true" &&
           this.objId === "contact") {
          // 编辑弹框标题修改为"编辑客户"
          this.tabName = this.$i18n.t("label.account");
          this.objectApi = "Account";
        }
        this.isTableEdit = true;
        this.$nextTick(() => {
          this.$refs.createEditObj.edit(row);
        });
      }
    },
    /**
     * 转移所有人
     */
    transferOwner(row) {
      this.id = row.data.id;
      this.initTransferOwner(this.objId, this.id);
      this.transferClientOwnerDialog = true;
    },
    /**
     * 更改客户所有人
     */
    transferClientOwner(row) {
      // 联系人列表"更改所有人"(个人客户生成的联系人)
      if(row.data.ispersonaccount &&
         row.data.ispersonaccount === "true" &&
         this.objId === "contact") {
        this.objId = "account";
      } else {
        this.objId = this.$route.params.objId;
      }
      this.id = row.data.id;
      this.initTransferOwner(this.objId, this.id);
      this.transferClientOwnerDialog = true;
    },
    /**
     * 保存转移所有人成功
     * ! 我看混入中使用了
     */
    saveTransferOwnerSuccess() {
      this.pageObj.dataList = [];
      this.pageNum = 1;
      this.getViewListData();
      this.closeTransferOwnerDialog();
    },
    /**
     * 关闭转移所有人Dialog
     */
    closeTransferOwnerDialog() {
      this.transferClientOwnerDialog = false;
    },
    /**
     * 新增/修改保存
     * @param {String} id:修改后数据id，用于表格单条数据更新
     */
    save(id) {
      if(id){
        this.id=id
        // 开启表格数据单条更新
        this.editFlag=true
      }
      // 控制表格出现骨架屏
      // this.pageNum = 1;
      this.getViewListData();
    },
    /**
     * 删除
     * @param {Object} row 删除行
     */
    del(row) {
      //项目管理中项目任务删除子任务时修改objectApi
      if (
        this.$route.path.substring(this.$route.path.length - 3) == "p03" &&
        row.data.their_task
      ) {
        this.objectApi = "cloudccSubtask";
      }
      if (this.objectApi === "CloudccProject") {
        //删除该项目，将删除项目和项目关联的所有信息，且数据无法恢复，是否确认删除？
        this.delContent = this.$i18n.t("label.projectManagement.delete.item");
      } else if (this.objectApi === "cloudccMilestone") {
        // 删除该里程碑，将删除里程碑和里程碑关联的所有信息，且数据无法恢复，是否确认删除？
        this.delContent = this.$i18n.t(
          "label.projectManagement.delete.milestone"
        );
      } else if (this.objectApi === "CloudccProblem") {
        //删除该问题，将删除问题和问题关联的所有信息，且数据无法恢复，是否确认删除？
        this.delContent = this.$i18n.t(
          "label.projectManagement.delete.question"
        );
      } else if (this.objectApi === "cloudccTask") {
        // '删除该任务，将删除任务和任务关联的所有信息，且数据无法恢复，是否确认删除？'
        this.delContent = this.$i18n.t("label.projectManagement.delete.task");
      } else if (this.objectApi === "cloudccSubtask") {
        // 删除该子任务，将删除子任务和子任务关联的所有信息，且数据无法恢复，是否确认删除？
        this.delContent = this.$i18n.t(
          "label.projectManagement.delete.subtasks"
        );
      } else {
        this.delContent = this.$i18n.t("label.weixin.confirm.delete");
      }
      this.id = row.data.id;
      this.dialogVisible = true;
    },
    /**
     * 确认删除数据
     */
    confirmDel() {
      this.isBtnLoading = true;
      let params = { id: this.id, objectApi: this.objectApi };
      // 审批中的记录二次确认删除
      if (this.isConfirmDel) {
        params.isConfirmDel = "true";
      }
      CommonObjApi.del(params)
        .then((res) => {
          // 审批中的记录需要二次确认才能删除,returnCode返回isConfirmDel时，说明时删除正在审批中的记录
          if (res.returnCode === "isConfirmDel") {
            // 二次确认弹窗
            this.isConfirmDel = "true";
            this.dialogVisible = true;
            this.delContent = res.returnInfo;
            this.isBtnLoading = false;
          } else {
            this.isConfirmDel = "";
            this.isBtnLoading = false;
            this.pageNum = 1;
            this.dialogVisible = false;
            this.$message.success(this.$i18n.t("label.ems.delete.success"));
            this.getViewListData();
          }
        })
        .catch(() => {
          this.isBtnLoading = false;
          this.isConfirmDel = "";
        });
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.dialogVisible = false;
      this.isConfirmDel = "";
    },
    /**
     * 详情
     * @param {Object} row 详情行
     */
    detail(row) {
      // 查找字段跳到对应详情页
      // 事件及任务类型名称和相关项跳转
      if (
        row.field.schemefieldType === "Y" ||
        row.field.lookupObj === "user" ||
        row.field.schemefieldName === "relateid"
      ) {
        CommonObjApi.getPermissionById({
          id: row.data[row.field.schemefieldName],
        }).then((res) => {
          if (!res.data.isQuery) {
            this.$message.warning(
              // "抱歉，您无权查看该条数据，请联系系统管理员。"
              this.$i18n.t("2018UI_Homepage_DataNoAccess_Info")
            );
            return false;
          }
        });
      }
    },
    /**
     * 列表视图
     * @param {String} id table的id
     */
    tableView(id) {
      if (this.objectApi == "CloudccKArticle") {
        this.$router.push({
          path: `/Knowledgearticles/CloudccKArticle/cloudcc_k_article/k02`,
          query: {
            viewId: id || this.viewId,
          },
        });
      }
      if (
        this.$route.path.indexOf("/commonObjects/views/table") === -1 &&
        this.objectApi !== "CloudccKArticle"
      ) {
        this.$router.push({
          path: `/commonObjects/views/table/${this.objectApi}/${this.objId}/${this.prefix}`,
          query: {
            viewId: id || this.viewId,
          },
        });
      }
    },
    /**
     * 看板视图
     */
    boardView() {
      if (this.$route.path.indexOf("/commonObjects/views/kanban") === -1) {
        this.$router.push({
          path: `/commonObjects/views/kanban/${this.objectApi}/${this.objId}/${this.prefix}`,
          query: {
            viewId: this.viewId,
          },
        });
      }
    },
    /**
     * 轮班计划视图
     */
    planView() {
      if (this.$route.path.indexOf("/commonObjects/views/plan") === -1) {
        this.$router.push({
          path: `/commonObjects/views/plan/${this.objectApi}/${this.objId}/${this.prefix}`,
          query: {
            viewId: this.viewId,
          },
        });
        this.$nextTick(() => {
          this.$refs.shiftPlan.renderPage();
        });
      }
    },
    /**
     * 分屏视图
     */
    multiScreen() {
      this.$router.push({
        path: `/commonObjects/multi-screen/${this.objectApi}/${this.objId}/${this.prefix}`,
        query: {
          sortFieldName: this.sortFieldName,
          sortField: this.sortField,
          sortDir: this.sortDir,
          viewId: this.viewId,
        },
      });
    },
    /**
     * 内联编辑
     */
    handleChange() {},
    /**
     * 自动换行
     */
    wordWrap() {
      //
    },
    /**
     * 锁定
     * @param {Object} field 要锁定的字段对象
     */
    locked(field) {
      let fiexdList = this.tableAttr.filter((item) => {
        return item.fixed === true;
      });

      if (fiexdList.length > 2 && field.locked) {
        Message.warning(
          this.$i18n.t("vue_label_commonobjects_view_fixed_at_most")
        );
        this.tableAttr.forEach((item) => {
          if (item.id === field.id) {
            item.fixed = false;
            item.locked = false;
          }
        });
      } else {
        this.tableAttr.forEach((item) => {
          if (item.id === field.id) {
            item.fixed = !item.fixed;
          }
        });
      }

      this.$forceUpdate();
      this.$refs.tablePanel.changeTableAttr(this.tableAttr);
    },
    /**
     * 修改按‘字段名’排序字段
     */
    changeFilterFiled(field) {
      this.filterField = field;
    },
    /**
     * 修改排序字段
     */
    changeSortFiled(field) {
      // this.pageNum = 1
      this.skippageNum = 1;
      // this.pageObj.dataList = []

      // 若排序字段不变，改变排序方式
      if (this.sortField === field.schemefieldName) {
        // this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
      } else {
        // 否则重置排序字段和排序方式
        this.clearSort();
        // this.sortDir = "asc";
        this.sortField = field.schemefieldName;
        this.sortFieldName = field.nameLabel;
      }
      // 刷新视图
      this.getViewListData("sort");
      this.$forceUpdate();
      this.$refs.tablePanel.changeTableAttr(this.tableAttr);
    },
    /**
     * 清除排序
     */
    clearSort() {
      this.tableAttr.forEach((item) => {
        item.sortByThis = false;
      });
    },

    /**
     * 当前页码发生变化时
     * @param {Number} val 页码
     */
    handleCurrentChange(val) {
      this.skippageNum = val;
      this.getViewListData(val);
      this.$refs.tablePanel.$refs.tablePanel.bodyWrapper.scrollTop = 0;
    },
    /**
     * 点击回到首页按钮
     */
    goHomePage() {
      this.skippageNum = 1;
      this.getViewListData();
    },
    /**
     * 筛选器：点击按钮及关闭的回调
     */
    filterBoard() {
      this.showScreen = !this.showScreen;
      this.isLabelView = false;
      this.isChart = false;
    },
    /**
     * 高级筛选器修改changeConditionValues传参，高级筛选分页必须从1开始查找，防止按照上次页数查询查出来为空
     * @param {Object} val 当前筛选条件
     * @param {String} curData 当前数据对象
     */
    changeConditionValues(val, curData) {
      this.conditionValues = val;
      this.curPushData = curData;
      if (
        this.viewId === "0" ||
        this.viewId === "1" ||
        this.viewId === "2" ||
        this.viewId === "3"
      ) {
        this.getViewListHeader();
      }
      this.showScreen = true;
      this.pageNum = 1;
      this.skippageNum = 1;
      this.getViewListData();
    },
    /**
     * 标签列表
     */
    tagManage() {
      this.isLabelView = !this.isLabelView;
      this.isChart = false;
      this.showScreen = false;
    },
    /**
     * 图表列表,根据对象id获取图表内的仪表板列表
     */
    async chartsBoard() {
      this.isChart = !this.isChart;
      this.showScreen = false;
      this.isLabelView = false;
      // 判断是否在点击图表按钮展开
      if (this.isChart) {
        // 判断仪表板列表是否有数据
        if (this.listDashboard.length === 0) {
          this.loadingDashboard = true;
          let params = {
            objId: this.objId, // 对象id
          };
          let data = await CommonObjApi.getDashboardListByObjId(params);
          if (data.result) {
            this.listDashboard = data.data.listDashboard;
          } else {
            this.listDashboard = [];
          }
          this.loadingDashboard = false;
        }
      }
    },
    /**
     * 前端导出视图数据
     */
    exportView() {
      if (!Array.isArray(this.pageObj.dataList)) return;
      // 表格头导出数据
      let headAry = [];
      // 表格头props，用于处理数据内容，保证顺序
      let propsAry = [];
      // 表格主体导出的数据
      let mainAry = [];
      // 表格导出表格头内容数据
      this.tableAttr.forEach((item) => {
        if (item.schemefieldName) {
          headAry.push(item.nameLabel);
          propsAry.push(item.schemefieldName);
        }
      });
      // 表格导出内容数据
      this.pageObj.dataList.forEach((item) => {
        let ary = [];
        propsAry.forEach((prop) => {
          if (item[prop + "ccname"]) {
            ary.push(item[prop + "ccname"]);
          } else {
            ary.push(item[prop]);
          }
        });
        mainAry.push(ary);
      });
      // 整合导出数据
      let data=[headAry,...mainAry];
      import('xlsx').then((XLSX) => {
        // 创建sheet
        let ws=XLSX.utils.aoa_to_sheet(data)
        // 创建workbook
        let wb=XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb,ws,'sheetName')
        XLSX.writeFile(wb,'exportView.xls')
      })
      
    },
    /**
     * 视图打印
     */
    print() {
      this.searchKeyWord = this.searchKeyWord ? this.searchKeyWord : null;
      let tagIdsArr = this.tagIds ? this.tagIds.replace(/,/g, "&") : null;
      this.exactSearchFlag = this.exactSearchFlag ? this.exactSearchFlag : null;
      window.open(
        `#/print-table/${this.objId}/${this.prefix}/${this.objectApi}/${this.viewId}/${this.skippageNum}/${this.pageSize}/${this.searchKeyWord}/${tagIdsArr}/${this.exactSearchFlag}`,
        "_parent - URL",
        "height=700, width=1210, top=50, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
      );
    },
    getMsgFormSon(data) {
      this.isLabelView = data;
    },
    /**
     * 筛选调用数据刷新
     */
    recall() {
      this.showScreen = false;
      if (this.$refs.shiftPlan) {
        this.$refs.shiftPlan.handleSearch();
      }
      this.pageNum = 1;
      this.skippageNum = 1;
      this.getViewListData();
    },
    /**
     * 设置视图刷新数据
     */
    refreshView() {
      this.getNewViewList();
    },
    /**
     * 标签页向父组件传值
     */
    tagValues(tagValue, allTag) {
      this.isAllTag = allTag;
      this.tagIds = tagValue;
      this.skippageNum = 1;
      this.getViewListData();
    },
    /**
     * 打开看板
     */
    actives() {
      this.$refs.kanban.open();
    },
    /**
     * 添加tags
     */
    addTag() {
      if (this.selectedList.length > 200 || this.lengths > 200) {
        this.$message.info(
          this.$i18n.t("vue_label_commonobjects_view_up_to_data")
        );
      } else {
        if (this.ids === "") {
          this.$message.info(this.$i18n.t("lable.opppdt.selPdt.leastone"));
        } else {
          this.$refs.addlabel.isShows();
        }
      }
    },
    /**
     * 获取新添加的标签
     */
    determineFun() {
      this.$refs.addlabel.isShows();
      this.getTagsByRecordId();
    },
    /**
     * 关闭添加按钮
     */
    closeAddBtn() {
      this.$refs.addlabel.isShows();
    },
    /**
     * 通过记录id获取标签集合
     */
    getTagsByRecordId() {
      CommonObjApi.GetTagsByRecordId({
        objId: this.$route.params.objId,
        recordId: this.id,
      }).then((res) => {
        this.labelArr = res.data;
      });
    },
    /**
     * 取消图表
     */
    quxiao() {
      this.isChart = false;
    },
    /**
     * 表格选中数据
     * @param {Array} val 当前选中的数据集合
     */
    onchange(val) {
      this.selectedList = val;

      if (this.bool == false) {
        this.selectedList = this.$store.state.checkedNum;
      }
      let ids = "";
      for (var i = 0; i < val.length; i++) {
        ids += val[i].id + ",";
      }
      //去掉最后一个逗号(如果不需要去掉，就不用写)
      if (ids.length > 0) {
        ids = ids.substr(0, ids.length - 1);
      }
      this.ids = ids;
      // 如果有选中的数据，隐藏视图切换器
      this.showFilter = this.selectedList.length === 0;
    },
    chat(val) {
      this.ids = val;
    },
    /**
     * 获得经度
     * @param {Object} val 经度值
     */
    longitude(val) {
      this.lengths = val;
    },
    /**
     * 判断按钮权限
     */
    business() {
      this.showFilter = false;
      this.viewsTypeList = [
        {
          icon: "List",
          name: this.$i18n.t("vue_label_help_list"),
        },
        {
          icon: "splitscreen",
          name: this.$i18n.t("vue_label_commonobjects_view_split_screen_view"),
        },
      ];
      this.showButtons = [];
      if (this.$route.params.objectApi === "Opportunity") {
        // 业务机会对象，可展示【销售漏斗、销售阶段推进】
        this.showButtons.push({
          label: this.$i18n.t("label.mobile.quickcreate.default.sellingfunnel"),
          action: "salesFunnel",
        });
        this.showButtons.push({
          label: this.$i18n.t("c184"),
          action: "promotionOfSalesStage",
        });
      }
      if (this.$route.params.type === "table") {
        // 对象已启用且属于列表视图，可展示【标签】
        this.showFilter = true;
        this.showButtons.push({
          label: this.$i18n.t("c183"),
          action: "tagManage",
        });
      }
      if (
        !(
          this.viewInfo.id === "0" ||
          this.viewInfo.id === "1" ||
          this.viewInfo.id === "2" ||
          this.viewInfo.id === "3"
        )
      ) {
        // 非四个特殊视图，可展示【看板视图】、【图表】
        this.viewsTypeList.push({
          icon: "Kanban",
          name: this.$i18n.t("vue_label_commonobjects_view_kanban_view"),
        });
        this.showButtons.push({
          label: this.$i18n.t("vue_label_commonobjects_view_chart"),
          action: "chartsBoard",
        });
      }
      // 先对按钮集合赋初始值,导出和打印视图（权限走导出报表权限）
      if (this.isExportReport) {
        this.showButtons.push(
          {
            label: this.$i18n.t("label.tabpage.exportview"),
            action: "export",
          },
          {
            label: this.$i18n.t("label.tabpage.printview"),
            action: "print",
          }
        );
      }

      //客户和潜在客户对象添加开启/关闭公海池按钮
      if (
        (this.prefix == "001" || this.prefix == "004") &&
        this.$store.state.userInfoObj.manageSetup == "true"
      ) {
        this.showButtons.push({
          label:
            this.highSeaPoolStatus &&
            this.highSeaPoolStatus.marketseaState == "true"
              ? this.$i18n.t("c916")
              : this.$i18n.t("c915"),
          action: "highSeasPoolStatus",
        });
      }
    },
    /**
     * 销售漏斗
     */
    salesFunnel() {
      const newPage = this.$router.resolve({
        path: `/commonObjects/hopper`,
      });
      window.open(newPage.href, "_blank");
    },
    /**
     * 销售阶段推进
     */
    promotionOfSalesStage() {
      const newPage = this.$router.resolve({
        path: `/commonObjects/upgrade-hopper`,
      });
      window.open(newPage.href, "_blank");
    },
    /**
     * 获取新的视图列表
     * @param {String} val 新视图id
     */
    viewIds(val) {
      this.newViewId = val;
      this.getNewViewList();
    },
    /**
     * 重置数据
     */
    recalles() {
      this.pageNum = 1;
      this.skippageNum = 1;
      this.recall();
    },
    /**
     * 获取对象的tag信息
     */
    async getObjectGetObjectInfos() {
      let params = {
        id: this.objId,
      };
      let res = await CommonObjApi.getObjectGetObjectInfo(params);
      if (res.result) {
        this.isTag = res.data.istag;
      }
    },
    /**
     * 获取看板视图展示数据
     * @param {String} val 搜索的关键字
     */
    async GetViewKanbanDisplays(val) {
      let params = {
        viewId: this.viewId,
        searchKeyWord: val,
        recordType: this.activeNames,
      };
      let res = await CommonObjApi.GetViewKanbanDisplay(params);
      if (res.result) {
        this.kanBanData = res.data;
      }
    },
    /**
     * 看板tab值
     * @param {String} val tab值
     */
    activeName(val) {
      this.activeNames = val;
    },
    /**
     * 打开MailChimp弹框
     */
    mailchimp() {
      this.$refs.MailChimp.open();
    },
    /**
     * 全选列表数据
     * @param {Boolean} val 全选状态
     */
    MailChimpSelect(val) {
      this.bool = val;
      if (val === true) {
        this.$refs.tablePanel.$refs.tablePanel.toggleAllSelection();
      } else {
        this.$refs.tablePanel.$refs.tablePanel.clearSelection();
        this.selectedList = this.$store.state.checkedNum;
        this.$store.state.checkedNum.forEach((item) => {
          this.$refs.tablePanel.$refs.tablePanel.toggleRowSelection(item, true);
        });
      }
    },
    /**
     * 从项目模板新建 保存 刷新
     */
    createdtemplainit() {
      this.getViewListData();
    },
    /**
     * 操作项 标记模板
     * @param {Object} item 当前项
     */
    marktemplate(val) {
      let marketep = "";
      if (val.action == "unmarktemplate") {
        marketep = false;
      } else {
        marketep = true;
      }
      let params = {
        id: val.data.id,
        template: marketep,
      };
      CommonObjApi.modifyProjectTemplate(params).then((res) => {
        if (res.result) {
          this.$message.success(res.returnInfo);
          this.$refs.tablePanel.checkboxmarktemplate(val.action);
        }
      });
    },

    /**
     * 判断队列是否展示
     */
    async checkQueueAndPartners() {
      let params = {
        id: this.objId,
      };
      let res = await CommonObjApi.checkQueueAndPartner(params);
      if (res.result) {
        this.isQueue = res.data.isQueue;
        if (res.data.isQueue) {
          this.queryQueueLists();
        }
      }
    },

    /**
     * 获取队列列表
     */
    async queryQueueLists() {
      let params = {
        id: this.objId,
      };
      let res = await CommonObjApi.queryQueue(params);
      if (res.result) {
        this.queryQueueList = res.data;
      }
    },
    /**
     * 判断客户与潜在客户下公海池是否开启
     */
    async getHighSeaPoolStatus() {
      if (this.prefix == "001" || this.prefix == "004") {
        let result = await getMarketseaSwitchState();
        if (result.result && result.data.length > 0) {
          this.highSeaPoolStatus = result.data.filter(
            (res) => res.objid == this.objId
          )[0];
          // 防止this.highSeaPoolStatus不是对象
          if (!this.highSeaPoolStatus) {
            this.highSeaPoolStatus = {};
          }
        }
      }
    },
    /**
     * 开启/关闭公海池操作
     */
    highSpoolAction(action) {
      if (action == "highSeasPoolStatus") {
        this.highSeasPdialog = true;
      }
    },
    /**
     * 关闭公海池弹框
     */
    closeDialog(status) {
      this.highSeasPdialog = false;
      //公海池开启状态更改后，更改按钮文字
      if (status) {
        this.highSeaPoolStatus.marketseaState = status;
        this.showButtons.forEach((res) => {
          if (res.action == "highSeasPoolStatus") {
            res.label =
              status == "false" ? this.$i18n.t("c915") : this.$i18n.t("c916");
          }
        });
      }
    },
    /**
     * 设置顶部按钮功能操作区域左侧宽度,在切换选中数据时，判断是否展示更多按钮
     */
    settingWidth() {
      if (
        document.getElementsByClassName("object_box") &&
        document.getElementsByClassName("object_box")[0].clientWidth &&
        document.getElementsByClassName("right-content") &&
        document.getElementsByClassName("right-content")[0].clientWidth &&
        document.getElementsByClassName("left-content")
      ) {
        // 整体宽度
        let topWidth =
          document.getElementsByClassName("object_box")[0].clientWidth;
        // 右侧宽度，左右间隙20
        let rightWidth =
          document.getElementsByClassName("right-content")[0].clientWidth + 20;
        // 设置右侧宽度
        document.getElementsByClassName("left-content")[0].style.width = `${
          topWidth - rightWidth
        }px)`;
      }
    },
  },
  watch: {
    prefix: {
      handler() {
        this.selectedList = [];
        //判断公海池状态
        this.getHighSeaPoolStatus();
      },
      immediate: true,
    },
    tabName() {
      // 列表表头日历更改为事件
      if (this.objectApi === "Event") {
        this.tabName = this.$i18n.t("label.event");
      }
    },
    // 获取路由
    $route: {
      handler: function (route) {
        // 获取到项目任务页面对象api
        this.projectTasksObjectApi = route.params.objectApi;
        // 初始化加载onload标识
        this.isOnload = true
        // 清空this.$CCDK.CCObject.setObjectList({ids})
        this.$CCDK.CCObject.setObjectList({ids: []})
      },
      immediate: true,
    },
    // 监听表格选中数据条数
    selectedList() {
      // 给定批量操作按钮最大宽度并处理按钮展示逻辑
      // 设置顶部按钮功能操作区域左侧宽度
      this.settingWidth();
      this.$nextTick(() => {
        this.$refs.batchOperationButtons.showMoreBtns();
      });
    },
  },
  beforeDestroy() {
    localStorage.setItem("relevantObjectLevel", 0);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table::before {
  height: 0;
}

::v-deep .el-table__fixed::before {
  height: 0;
}

.groupTitle {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  padding-left: 20px;
  background: #f0f0f0;
}

.objectTableMain {
  border-left: none;
  border-right: none;
  border-radius: 3px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .object_box {
    border-radius: 3px;
    border: 1px solid #dedcda;
    flex: 1;
    overflow: auto;
    background: #fff;
    display: flex;
    flex-direction: column;
  }
}

/* 标签列表位置 */
.LabelView {
  // height: 88%;
  position: absolute;
  right: 11px;
  top: 111px;
  z-index: 99;
}

/* 图表位置 */
.chart {
  width: 300px;
  height: calc(100% - 116px);
  // height: 88%;
  position: absolute;
  right: 11px;
  top: 105px;
  z-index: 99;
}

.topContent {
  display: flex;
  justify-content: space-between;
}

.left-content {
  padding: 15px 10px 16px 20px;
  display: flex;
}

.right-content {
  padding: 15px 20px 16px 0;
  display: flex;

  .searchWrapper {
    margin-right: 8px;
    height: 32px;
  }
}

.add_label {
  position: absolute;
  top: 57px;
  left: 35%;
}
.selectnum {
  height: 12px;
  font-size: 12px;
  margin-top: -20px;

  font-weight: 400;
  color: #666666;
  padding-bottom: 22px;
}
.checkboxs {
  margin-left: 6px;
  font-size: 12px;
  line-height: 28px;
}
.spancolor {
  color: #fa6400;
}
.spans {
  height: 12px;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  padding-top: 12px;
}
.mtransferli {
  list-style: inside;
  height: 34px;
  font-size: 12px;

  font-weight: 400;
  color: #0c0b0b;
  line-height: 18px;
}
/*批量新增css*/
.tank {
  height: 480px;
  background: rgba(255, 255, 255, 1);
  z-index: 6;
  margin: 100px auto 0;
}
.title {
  height: 53px;
  line-height: 53px;
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  color: rgba(109, 114, 120, 1);
  font-size: 18px;
}
.btnp {
  font-weight: bold;
  font-size: 17px;
}
.btnx {
  font-size: 16px;
}

.listulFir {
  height: 40px;
  min-width: 100%;
  border: 1px solid rgba(190, 225, 255, 1);
  border-left: none;
  display: inline-flex;
  background: rgba(222, 240, 253, 1);
}
.listulSec:nth-of-type(2n) {
  height: 40px;
  display: inline-flex;
  background: rgba(240, 248, 255, 1);
  min-width: 100%;
}
.listulSec:nth-of-type(2n + 1) {
  height: 40px;
  display: inline-flex;
  background: white;
  min-width: 100%;
}
.firstLi {
  border-right: 1px solid rgba(190, 225, 255, 1);
  min-width: 80px;
  text-align: center;
}
.secondLi {
  border-right: 1px solid rgba(190, 225, 255, 1);
  text-align: center;
  width: 180px;
  line-height: 40px;
}
::v-deep .el-input {
  height: 30px;
  width: 100%;
  text-align: center;
}
::v-deep .el-input__inner {
  height: 30px;
  width: 100%;
}
::v-deep .el-button--mini {
  padding: 7px 7px;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgba(51, 51, 51, 1);
}
::v-deep .el-input__icon {
  height: auto;
}
.al {
  margin: 0 24px;
  width: auto;
  overflow: auto;
  max-height: 250px;
  border: 1px solid rgba(190, 225, 255, 1);
}
::v-deep .el-input__icon {
  margin-top: -4px;
}
.tianjia {
  margin-top: 20px;
  cursor: pointer;
  width: 32px;
  margin-bottom: 10px;
  margin-left: 16px;
}
ul {
  margin-bottom: 0;
}
.block {
  background: #fff;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  z-index: 9;
}

.main-content-box {
  display: flex;
  height: calc(100% - 64px);
  // border-top: 1px solid #e1e1e1;

  /* 筛选器位置 */
  .screen {
    height: 100%;
    border-right: 1px solid #bbb;
  }

  .tablePanel {
    flex: 1;
    overflow: auto;
  }
}

.go_homepage {
  margin-left: 20px;
  cursor: pointer;
  color: #006dcc;
}
</style>
